import { render, staticRenderFns } from "./PickAnswer.vue?vue&type=template&id=fc927d00&scoped=true"
import script from "./PickAnswer.vue?vue&type=script&lang=ts"
export * from "./PickAnswer.vue?vue&type=script&lang=ts"
import style0 from "./PickAnswer.vue?vue&type=style&index=0&id=fc927d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc927d00",
  null
  
)

export default component.exports